import React, { useState, useRef, useEffect } from "react";
import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import { Camera, Images, RefreshCw, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import jsQR from "jsqr";
import QRCodeGenerator from "../../components/QRCodeGenerator";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const ScanUtente = () => {
    const [id, setId] = useState(null);
    const [scanning, setScanning] = useState(false);
    const [data, setData] = useState("");
    const [operazioni, setOperazioni] = useState([]);
    const [selectedOperazione, setSelectedOperazione] = useState("");
    const [qrCodeURL, setQRCodeURL] = useState("");
    const [stato, setStato] = useState("");
    const [descrizioneManut, setDescrizioneManut] = useState("");
    const [isScanned, setIsScanned] = useState(true);
    const [isTakingPhoto, setIsTakingPhoto] = useState(false);
    const [facingEnv, setFacingEnv] = useState(true);
    const [descrizioneFoto, setDescrizioneFoto] = useState("");
    const navigate = useNavigate();
    const canvasScan = useRef(null);
    const canvasCamera = useRef(null);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (selectedOperazione !== "") {
            const op = operazioni.find((o) => o["ID"] === Number(selectedOperazione));
            setStato(op["StatoRisultante"]);
        } else {
            setStato("");
        }
    }, [selectedOperazione]);

    useEffect(() => {
        if (id) {
            QRCodeGenerator.generateQRCode(id)
                .then(url => setQRCodeURL(url))
                .catch(error => console.error(error));
        }
    }, [id]);

    const onload = async () => {
        try {
            isLoading = true;

            await loadFooter();

            const r3 = await fetch('/getOperazioni', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd3 = await r3.json();
            // console.log(rd3);
            if (r3.status === 500) {
                alert(rd3.error);
                console.error(rd3.error);
                navigate("/dashUtente");
            } else {
                isLoading = false;
                setOperazioni(rd3.filter((d) => d["Obsoleto"] === false));

                if (document.cookie.split("IDComponente=").length > 1) {
                    setIsScanned(false);
                    scanSuccess(document.cookie.split("IDComponente=")[1].split(";")[0]);
                    document.cookie = "IDComponente=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                }
            }

        } catch (error) {
            alert("Errore durante il caricamento della pagina");
            console.log(error);
            navigate("/dashUtente");
        }

    };

    const handleStartScan = async () => {
        const newScanning = !scanning;
        setScanning(newScanning);
        if (newScanning) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: 'environment' }
                    }
                });
                const video = document.querySelector('video#scan');
                video.srcObject = stream;
                video.onloadedmetadata = () => {
                    video.play().then(() => {
                        video.removeAttribute('hidden');
                        setScanning(true);
                        setId(null);
                        requestAnimationFrame(detectQRCode);
                    }).catch(err => {
                        console.error("Errore avvio riproduzione:", err);
                    });
                };
            } catch (error) {
                alert("Errore nella lettura");
                // alert(error);
                console.log(error);
                window.location.reload();
            }
        }
        else {
            handleStopScan();
        }
    };

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasScan.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                    scanSuccess(code.data);
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
            window.location.reload();
        }
    };

    const handleStopScan = () => {
        const video = document.querySelector('video#scan');
        const stream = video.srcObject;
        try {
            const tracks = stream.getTracks();

            tracks.forEach(function (track) {
                track.stop();
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleStartCamera = async () => {
        const newTakingPhoto = !isTakingPhoto;
        setIsTakingPhoto(newTakingPhoto);
        if (newTakingPhoto) {
            try {
                setFacingEnv(true);
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: 'environment' }
                    }
                });
                const video = document.querySelector('video#camera');
                video.srcObject = stream;
                video.onloadedmetadata = () => {
                    video.play().then(() => {
                        video.removeAttribute('hidden');
                    }).catch(err => {
                        console.error("Errore avvio riproduzione:", err);
                    });
                };
            } catch (error) {
                console.log(error);
                window.location.reload();
            }
        } else {
            handleStopCamera();
        }
    };

    const handleStopCamera = () => {
        const video = document.querySelector('video#camera');
        const stream = video.srcObject;
        try {
            const tracks = stream.getTracks();
            tracks.forEach(function (track) {
                track.stop();
            });
            setIsTakingPhoto(false);
        } catch (error) {
            console.log(error);
            window.location.reload();
        }
    };

    const switchCamera = async () => {
        const video = document.querySelector('video#camera');
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        const newFacingEnv = !facingEnv;
        setFacingEnv(newFacingEnv);
        try {
            const newStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: newFacingEnv ? { ideal: 'environment' } : { ideal: 'user' }
                }
            });
            video.srcObject = newStream;
            video.onloadedmetadata = () => {
                video.play().then(() => {
                    video.removeAttribute('hidden');
                }).catch(err => {
                    console.error("Errore avvio riproduzione:", err);
                });
            };
        }
        catch (error) {
            console.log(error);
            window.location.reload();
        }
    };

    const takePhoto = async () => {
        if (!canvasCamera.current) return;
        try {
            const video = document.querySelector('video#camera');
            const canvas = canvasCamera.current;
            const context = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            const img = canvas.toDataURL("image/jpeg");

            const formData = new FormData();
            const blob = dataURLToBlob(img);
            formData.append("image", blob);
            formData.append("CodiceDominio", infoUtente.CodiceDominio);
            formData.append("IDComponente", data["ID"]);
            formData.append("Descrizione", descrizioneFoto);
            formData.append("NomeUtente", infoUtente.Nome);
            formData.append("CognomeUtente", infoUtente.Cognome);
            const timestamp = new Date().toISOString().replace('T', ' ').replace(/\..+/, '');
            formData.append("Timestamp", timestamp);

            const r = await fetch("/addFoto", {
                method: "POST",
                body: formData,
            });

            if (r.status !== 200) {
                const rd = await r.json();
                alert(rd.error);
                console.error(rd.error);
            }
            else {
                alert("Foto caricata con successo");
                setDescrizioneFoto("");
            }
        } catch (error) {
            alert("Errore durante l'upload dell'immagine: ", error);
            console.error("Errore nell'upload dell'immagine:", error);
        }
    };

    // Funzione per convertire dataURL in Blob
    const dataURLToBlob = (dataURL) => {
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    const scanSuccess = async (qrCode) => {
        try {
            isLoading = true;
            const r1 = await fetch('/getComponente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    ID: qrCode
                })
            });
            const rd1 = await r1.json();

            if (r1.status !== 200) {
                alert(rd1.error);
                console.error(rd1.error);
                window.location.reload();
            } else {
                const r2 = await fetch('/getGestioneUtente', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDUtente: infoUtente.ID
                    })
                });

                const rd2 = await r2.json();

                if (r2.status === 500) {
                    alert(rd2.error);
                    console.error(rd2.error);
                    window.location.reload();
                }
                else {
                    isLoading = false;
                    if (rd2[0]["IDAzienda"] === null) {
                        setId(rd1[0]["ID"]);
                        setData(rd1[0]);
                    }
                    else {
                        if (rd2.filter((d) => d["IDAzienda"] === rd1[0]["IDAzienda"]).length === 0) {
                            alert("Non hai i permessi per eseguire operazioni su questo componente");
                            window.location.reload();
                        }
                        else {
                            setId(rd1[0]["ID"]);
                            setData(rd1[0]);
                        }
                    }
                }
            }

        } catch (error) {
            alert("Errore durante la scansione del codice QR");
            console.log(error);
            window.location.reload();
        }
    };

    const handleStampa = async () => {
        //open window to print all qrCodes
        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.write("<html><head><title>QRCode</title></head><body>");
        printWindow.document.write("<img src='" + qrCodeURL + "' alt='QR Code' />");
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        await new Promise((resolve) => setTimeout(resolve, 500));
        printWindow.print();
    };

    const handleManutenzione = async () => {
        if (descrizioneManut === "") {
            alert("Inserire una descrizione");
            return;
        }
        try {
            isLoading = true;
            const response = await fetch('/addManutenzione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    EmailUtente: infoUtente.Email,
                    IDAzienda: data["IDAzienda"],
                    IDComponente: data["ID"],
                    Descrizione: descrizioneManut
                })
            });

            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                navigate('/dashUtente');
            }
        } catch (error) {
            alert("Errore durante la manutenzione");
            console.log(error);
            window.location.reload();
        }
    };

    const handleOperazione = async () => {
        if (descrizioneManut === "") {
            alert("Inserire una descrizione");
            return;
        }
        try {
            isLoading = true;
            const response = await fetch('/addOperazioneUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    EmailUtente: infoUtente.Email,
                    IDAzienda: data["IDAzienda"],
                    IDComponente: data["ID"],
                    Descrizione: descrizioneManut,
                    IDOPerazione: Number(selectedOperazione)
                })
            });

            if (response.status === 500) {
                const responseData = await response.json();
                alert(responseData.error);
                console.error(responseData.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                navigate('/dashUtente');
            }
        } catch (error) {
            alert("Errore durante la manutenzione");
            console.log(error);
            window.location.reload();
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={!isScanned ? "INFO COMP" : "SCAN QR"} />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                {
                    isScanned ? (
                        <div className="flex justify-center items-center mb-4">
                            <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleStartScan}>
                                {scanning ? "Stop Scan" : (id ? "Scan Again" : "Start Scan")}
                            </button>
                        </div>
                    ) : null
                }
                {
                    scanning ? (
                        <div className="flex justify-center items-center text-black dark:text-white mt-4">
                            <video muted autoPlay playsInline hidden width="70%" height="70%" id="scan" className="rounded"></video>
                            <canvas
                                ref={canvasScan}
                                style={{ display: 'none' }}
                                hidden
                            />
                        </div>
                    ) : (
                        id ? (
                            <>
                                <div className="flex justify-center items-center text-black dark:text-white mb-4">
                                    <img src={qrCodeURL} alt="QR Code" />
                                </div>
                                <div className="flex justify-center items-center text-black dark:text-white">
                                    <button className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded" onClick={handleStampa}>
                                        STAMPA
                                    </button>
                                </div>
                                <div className="w-full max-w-lg text-center text-black dark:text-white mt-8">
                                    <p className="mb-2">Nome componente: {data["Codice"] !== '' ? data["Codice"] : "-----"}</p>
                                    <p className="mb-2">Tipologia: {data["DescrizioneTipologia"]}</p>
                                    <p className="mb-2">Cliente: {data["NomeAzienda"]}</p>
                                    <p className="mb-2">Data di installazione: {data["DataInstallazione"]}</p>
                                    <p className="mb-2">Descrizione: {data["Descrizione"]}</p>
                                    <p className="mb-2">Stato: {data["StatoAttuale"]}</p>
                                    <p className="mb-2">Ultima operazione: {data["UltimaOperazione"] ? data["UltimaOperazione"] : "-----"}</p>
                                    <p className="mb-2">Data ultima operazione: {data["DataUltimaOperazione"] ? data["DataUltimaOperazione"] : "-----"}</p>
                                    <p className="mb-2">Prossima manutenzione: {data["ProssimaManutenzione"]}</p>
                                </div>
                                <div className="grid grid-cols-1 text-center mt-8">
                                    <div className="flex justify-center items-center">
                                        <button
                                            className="flex justify-center items-center text-blue-500 mr-8"
                                            onClick={() => {
                                                handleStartCamera();
                                            }}
                                        >
                                            <Camera size={40} />
                                        </button>
                                        <button
                                            className="flex justify-center items-center text-blue-500"
                                            onClick={() => {
                                                document.cookie = "IDComponente=" + data["ID"] + "; path=/";
                                                navigate('/dashUtente/foto');
                                            }}
                                        >
                                            <Images size={40} />
                                        </button>
                                    </div>
                                    {
                                        isTakingPhoto ? (
                                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
                                                <div className="bg-white dark:bg-gray-800 rounded-lg p-4 max-w-[90%] max-h-[95%] text-black dark:text-white">
                                                    <div className="flex justify-between items-center mb-4">
                                                        <h2 className="text-xl font-bold">Fotocamera</h2>
                                                        <button className="text-red-500" onClick={handleStartCamera}>
                                                            <X size={30} />
                                                        </button>
                                                    </div>
                                                    <div className="grid grid-cols-1 text-black dark:text-white mt-4">
                                                        <div className="w-full max-w-lg text-center mb-4">
                                                            <label htmlFor="descrizioneFoto" className="block mb-2">Descrizione foto:</label>
                                                            <textarea
                                                                id="descrizioneFoto"
                                                                className="rounded bg-white dark:bg-gray-800 border-2 border-black dark:border-white p-1 w-full"
                                                                rows={3}
                                                                value={descrizioneFoto}
                                                                onChange={e => setDescrizioneFoto(e.target.value)}
                                                                placeholder="Inserisci una descrizione per la foto"
                                                            />
                                                        </div>
                                                        <video muted autoPlay playsInline hidden width="100%" height="70%" id="camera" className="rounded justify-self-center"></video>
                                                        <canvas
                                                            ref={canvasCamera}
                                                            style={{ display: 'none' }}
                                                            hidden
                                                        />
                                                        <div className="grid grid-cols-3 justify-items-center gap-4 mt-2">
                                                            <div></div>
                                                            <button
                                                                className="w-16 h-16 rounded-full bg-black dark:bg-white shadow-lg"
                                                                onClick={takePhoto}
                                                            >
                                                                <Camera size={40} className="text-black dark:text-white" />
                                                            </button>
                                                            <button
                                                                className="flex justify-start items-center text-black dark:text-white"
                                                                onClick={switchCamera}
                                                            >
                                                                <RefreshCw size={40} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    }
                                </div>
                                <div className="justify-self-center text-center mt-8">
                                    MANUTENZIONE
                                </div>
                                <div className="grid grid-cols-2 mx-5 mt-2">
                                    <p className="">Descrizione: </p>
                                    <input type="text" className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" value={descrizioneManut} onChange={(e) => setDescrizioneManut(e.target.value)}>
                                    </input>
                                </div>
                                <div className="justify-self-center text-center">
                                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2" onClick={handleManutenzione}>
                                        Esegui Manutenzione
                                    </button>
                                    <p className="justify-self-center mt-2 mb-2">Oppure</p>
                                    <div className="grid grid-cols-2 gap-4 mb-2">
                                        <p>Operazione:</p>
                                        <select className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" value={selectedOperazione} onChange={(e) => setSelectedOperazione(e.target.value)}>
                                            <option value="" className="text-center">----</option>
                                            {
                                                operazioni.map((op) => (
                                                    <option value={op["ID"]} key={op["ID"]}>{op["Descrizione"]}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <p>Stato: {stato}</p>
                                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleOperazione}>
                                        Conferma Operazione
                                    </button>
                                </div>
                            </>
                        ) : null
                    )}
                <FooterUtente />
            </div>
        </div >
    );
};

export default ScanUtente;